import App from '../apps/phio/components/App';
import routes from '../routes/phioRoutes';

export default () => {
    return <App routes={routes} />;
};
